import React, { useEffect, useRef } from 'react';
import { Alert } from 'react-bootstrap';
import OtpInput from 'react-otp-input';
import { useTimer } from 'react-timer-hook';

type Props = {
  resendHandler?: () => void;
  otpChangeHandler: (value: string) => void;
  enableResendTimer: boolean;
  isCentered?: boolean;
  resendButtonText?: string;
  otpLabel?: string;
  ackMessage?: string;
  isDisabled?: boolean;
  ackMessageType?: 'success' | 'fail';
  otpValue: string;
  resendInterval: number;
  numInputs: number;
};

const OtpWithTimer = ({
  otpLabel,
  enableResendTimer,
  resendHandler,
  isCentered = false,
  otpChangeHandler,
  resendButtonText,
  isDisabled,
  ackMessage,
  ackMessageType,
  numInputs,
  otpValue,
  resendInterval,
}: Props) => {
  const otpRef = useRef(null);

  useEffect(() => {
    if (otpValue?.length === 0) otpRef.current.focusInput(0);
  }, [otpValue]);

  const getResendTime = () => {
    const expTime = new Date();
    expTime.setSeconds(expTime.getSeconds() + resendInterval);
    return expTime;
  };

  const { seconds, minutes, isRunning, restart } = useTimer({
    expiryTimestamp: getResendTime(),
    onExpire: () => console.log('timer expired'),
  });

  const onResendClick = () => {
    restart(getResendTime());
    resendHandler();
  };

  return (
    <>
      <div className='form-group mb-2 mx-2'>
        {otpLabel && <p className='h5 text-justify mb-3'>{otpLabel}</p>}
        <div
          className='d-flex flex-column justify-content-center'
          style={isCentered ? null : { width: 'fit-content' }}
        >
          <OtpInput
            ref={otpRef}
            isDisabled={isDisabled}
            inputStyle={{
              width: '2.5rem',
              height: '2.5rem',
              margin: '10px 0.3rem',
              fontSize: '20px',
              borderRadius: 4,
              border: '2px solid #DDA838',
            }}
            focusStyle={{
              border: '2px solid #DDA838',
            }}
            containerStyle={
              isCentered ? { display: 'flex', justifyContent: 'center' } : null
            }
            value={otpValue}
            onChange={(value) => {
              otpChangeHandler(value);
            }}
            isInputNum
            isInputSecure
            numInputs={numInputs}
            shouldAutoFocus
          />

          {enableResendTimer && (
            <div className='d-flex justify-content-end'>
              {isRunning ? (
                <div className='text-muted'>
                  <small>{`${minutes}:${seconds}`}</small>{' '}
                </div>
              ) : (
                <div
                  className='link-primary'
                  role='button'
                  onClick={onResendClick}
                >
                  <small>{resendButtonText}</small>
                </div>
              )}
            </div>
          )}
        </div>

        {ackMessage && (
          <div className={'my-2'}>
            <Alert
              variant={`${ackMessageType == 'success' ? 'success' : 'danger'}`}
            >
              {ackMessage}
            </Alert>
          </div>
        )}
      </div>
    </>
  );
};

export default React.memo(OtpWithTimer);
